/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Swal_Confirm_ButtonInputs */

const en_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Browser & Restart`)
};

const fr_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le Navigateur et Redémarrer`)
};

const de_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser öffnen und neu starten`)
};

const it_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il browser e riavvia`)
};

const ru_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте браузер и перезапустите его.`)
};

const es_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra el navegador y reinicie`)
};

const zh_cn2_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开浏览器并重启`)
};

const ja_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザを開いて再起動`)
};

const hi_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्राउज़र खोलें और पुनः आरंभ करें`)
};

const pt_pt2_signup_swal_confirm_button = /** @type {(inputs: Signup_Swal_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra o navegador e reinicie.`)
};

/**
* | output |
* | --- |
* | "Open Browser & Restart" |
*
* @param {Signup_Swal_Confirm_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_swal_confirm_button = /** @type {((inputs?: Signup_Swal_Confirm_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Swal_Confirm_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_swal_confirm_button(inputs)
	if (locale === "de") return de_signup_swal_confirm_button(inputs)
	if (locale === "it") return it_signup_swal_confirm_button(inputs)
	if (locale === "ru") return ru_signup_swal_confirm_button(inputs)
	if (locale === "es") return es_signup_swal_confirm_button(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_swal_confirm_button(inputs)
	if (locale === "ja") return ja_signup_swal_confirm_button(inputs)
	if (locale === "hi") return hi_signup_swal_confirm_button(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_swal_confirm_button(inputs)
	return en_signup_swal_confirm_button(inputs)
});